export const state = {
  currentAppealMeta: {
    label: null,
    ratingAwaiting: null
  }
};

export const getters = {
  getCurrentAppealMeta: state => state.currentAppealMeta
};

export default {
  state,
  getters
};
